

const CancellationPolicy = () => {

    return (
        <div>
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 my-5 pt-2 text-muted">
                            <h2 className="text-primary">Cancellation & Exchange Policy</h2>
                            <p className=""><b>Cancellation Policy</b></p>
                            <p><li>An order will instantly be canceled if the billing information is inaccurate or incomplete.</li></p>
                            <p><li>If a customer doesn’t confirm their order within 24-hours of placement, the order will be marked as ‘discarded’.</li></p>
                            <p><li>An order can only be canceled within 12-hours of ordering from a customer’s end.</li></p>
                            <p><li>If a customer cancels an order past the suggested time limit, their appeal will not be accepted.</li></p>

                            <p><b>Exchange Policy</b></p>
                            <p><li>An item can only be exchanged in case of any defects with proof, within 2 days of delivery.</li></p>
                            <p><li>An item will only be exchanged with an intact duplicate that doesn’t contain the same defects as the former.</li></p>
                            <p><li>To exchange a purchased product, the customer will have to submit a form with proof and details of the defected items.</li></p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default CancellationPolicy
